import WriteableReviewListItem from './WriteableReviewListItem';
import useStyles from './useStyles';
import { CapaRfqAvailableReviews } from '@generated/graphql';
import { CustomizedButton, CustomizedTypography } from '@components/Customized';
import { CircularProgress } from '@material-ui/core';
import { ChevronDown } from '@carbon/icons-react';

interface Props {
  loading: boolean;
  writeableRfqs?: CapaRfqAvailableReviews[];
  visibleCount: number;
  handleVisibleCount: () => void;
}

const WriteableReviewPresenter = ({
  loading,
  writeableRfqs = [],
  visibleCount,
  handleVisibleCount
}: Props) => {
  const classes = useStyles();

  const reviewsTotalCount = writeableRfqs.length;

  const invisibleMoreButton =
    visibleCount === reviewsTotalCount || reviewsTotalCount < 5;

  return (
    <div className={classes.root}>
      {writeableRfqs?.length === 0 && (
        <div className="no-review">
          {loading ? (
            <CircularProgress />
          ) : (
            <CustomizedTypography variant="h4" color="textSecondary">
              작성 가능한 리뷰가 없습니다.
            </CustomizedTypography>
          )}
        </div>
      )}

      {writeableRfqs.slice(0, visibleCount)?.map((reviewInfo, index) => (
        <WriteableReviewListItem
          gutterBottom={visibleCount - 1 !== index}
          key={reviewInfo.rfqCreatedAt}
          reviewInfo={reviewInfo}
        />
      ))}

      {invisibleMoreButton ? null : (
        <div className={classes.visibie}>
          <CustomizedButton
            size="medium"
            color="default"
            onClick={handleVisibleCount}
            endIcon={<ChevronDown size={20} />}
          >
            더보기
          </CustomizedButton>
        </div>
      )}
    </div>
  );
};

export default WriteableReviewPresenter;
